import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Toast } from 'vant'
import { replaceParamVal } from "@/utils/utility";

import { connectWebViewJavascriptBridge } from "@/utils/utility";
// 创建 axios 实例

const service = axios.create({
  baseURL: process.env.VUE_APP_API_TARD_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      //   notification.error({
      //     message: 'Forbidden',
      //     description: data.message
      //   })
      Toast.fail(data.message)
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: 'Authorization verification failed'
      //   })
      Toast.fail('Authorization verification failed')
      // if (token) {
      //     // store.dispatch('Logout').then(() => {
      //     //     setTimeout(() => {
      //     //         window.location.reload()
      //     //     }, 1500)
      //     // })
      // }
    }
    if (error.response.status === 404 && error.response.data.code === 401) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: error.response.data.msg
      //   })
      Toast.fail(error.response.data.msg)
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  var token1 = localStorage.getItem("Access-Token");

  const tenantId = localStorage.getItem('tenantId')
  // console.log(token1)
  if (token1) {
    config.headers['Authorization'] = token1 // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (tenantId) {
    config.headers['TenantId'] = tenantId // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  // const corpAppid = Vue.ls.get(CORP_APPID);
  // if (corpAppid && corpAppid != 0) {
  //   config.headers['corpAppid'] = corpAppid;
  // }
  return config
}, err)

service.interceptors.response.use((response) => {
  if (response.data.code == 401) {
    Vue.ls.remove(ACCESS_TOKEN);

  }
  return response.data
}, err)
const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
